import React from "react"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"
import "./featured-article.scss"

const FeaturedArticle = props => {
  const monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ]
  const getDate = date => {
    var dateForm = new Date(date)
    return dateForm.getDate() + " de " + monthNames[dateForm.getMonth()] //+ " de " + dateForm.getFullYear()
  }
  return (
    <>
      {props.item && (
        <a
          href={removeDoubleSlash("/magazin/nuestro-mundo/" + props.item.slug)}
          className="f-featured-card f-featured-card-thirditem"
        >
          <div className="f-featured-card-info ">
            <p className="f-featured-card-info-title">
              Escrito por <span>nuestras</span> usuarias
            </p>
            {props.item.fechaDePublicacion && (
              <span className="f-featured-card-info-user-date">
                {getDate(props.item.fechaDePublicacion)}
              </span>
            )}
            <div className="f-featured-card-info-interaction">
              <span
                className="icon-save "
                onClick={event => {
                  event.preventDefault()
                  props.setModalState()
                }}
              />
              <span className="icon-heart " />
            </div>
            <div className="f-featured-card-info-user">
              <div className="f-featured-card-info-user-info">
                <img
                  className="f-featured-card-info-user-img"
                  alt={props.item.imagenCreadorArticulo.description}
                  src={props.item.imagenCreadorArticulo.file.url}
                />
                <span className="f-featured-card-info-user-name">
                  {props.item.nombreCreadorArticulo}
                </span>
              </div>
              <div>
                <span className="f-featured-card-info-category">
                  {props.item.categorias[0].titulo}
                </span>
                <h3>{props.item.tituloArticulo}</h3>
                <p className="f-featured-card-info-description">
                  {props.item.descripcionArticulo}
                </p>
              </div>
            </div>
          </div>
        </a>
      )}
    </>
  )
}

export default FeaturedArticle
